export class CommissionPaymentFrequency {
    ID: number;
    Name: string;
}

export default CommissionPaymentFrequency;